export const EmptyAttachmentsIllustration = () => (
  <svg width="140" height="112" viewBox="0 0 200 160" role="img" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
    <circle cx="46" cy="52" r="3" fill="#C7D2FE" />
    <circle cx="58" cy="40" r="2" fill="#A5B4FC" />
    <circle cx="164" cy="46" r="2" fill="#C7D2FE" />
    <rect x="30" y="70" width="140" height="14" rx="4" fill="#E0E7FF" stroke="#C7D2FE" strokeWidth="1.5" />
    <path d="M20,84 L180,84 L165,140 L35,140 Z" fill="#EEF2FF" stroke="#C7D2FE" strokeWidth="1.5" />
    <path
      d="M75,95 L120,95 L130,105 L130,135 L75,135 Z"
      fill="#F5F3FF"
      stroke="#A5B4FC"
      strokeWidth="1.8"
      strokeDasharray="4 4"
    />
    <path d="M120,95 L120,105 L130,105" fill="none" stroke="#818CF8" strokeWidth="1.5" />
    <circle cx="150" cy="70" r="16" fill="#6366F1" />
    <rect x="148" y="62" width="4" height="16" rx="1" fill="#FFFFFF" />
    <rect x="142" y="68" width="16" height="4" rx="1" fill="#FFFFFF" />
  </svg>
);
